import React, { useMemo, useEffect, useRef } from "react";
import { CometChatHome } from "../CometChat/components/CometChatHome/CometChatHome";
import { AppContextProvider } from "../CometChat/context/AppContext";
import { CometChatProvider } from "../CometChat/context/CometChatContext";
import { CometChatConversationEvents, CometChatGroupEvents } from "@cometchat/chat-uikit-react";
import MainLayout from "../layouts/MainLayout";
import Container from "@mui/material/Container";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import useDraftMessages from "../hooks/useDraftMessages";
import { trackClickEvent } from "../mixpanel";
import "../CometChat/styles/MessagesMobile.css";
import "./Groups.css";

const Groups = () => {
  // Create conversation request builder that only shows group conversations
  const conversationsRequestBuilder = useMemo(() => {
    return new CometChat.ConversationsRequestBuilder()
      .setLimit(30)
      .withBlockedInfo(true)
      .setConversationType("group");
  }, []);

  const groupsContainerRef = useRef(null);
  
  // Use draft messages hook for group drafts
  useDraftMessages(groupsContainerRef);

  useEffect(() => {
    trackClickEvent('Discussion Group Page Opened');

    // Handle conversation deletion events
    const conversationDeleted = CometChatConversationEvents.ccConversationDeleted.subscribe(
      (conversation) => {
        console.log('Group conversation deleted:', conversation);
        // Force refresh of conversations list
        window.location.reload();
      }
    );

    return () => {
      conversationDeleted?.unsubscribe();
    };
  }, []);

  return (
    <>
      <MainLayout
        currentPage="Discussion Groups"
        currentPageTitle="Discussion Groups"
        noFooter={true}
        noFeedback={true}
      >
        <Container>
          <div
            className="groups-page-container"
            ref={groupsContainerRef}
            style={{
              height: "calc(100vh - 300px)",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "visible",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <CometChatProvider 
              authBuilderSetting={{
                layout: {
                  withSideBar: true,
                  tabs: ['groups'],
                  chatType: 'group'
                }
              }}
            >
              <AppContextProvider>
                <CometChatHome 
                  conversationsRequestBuilder={conversationsRequestBuilder}
                />
              </AppContextProvider>
            </CometChatProvider>
          </div>
        </Container>
      </MainLayout>
    </>
  );
};

export default Groups;